var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserAssi({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 21 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "user-check",
    d: "M7,10.5A5.25,5.25,0,1,0,1.75,5.25,5.255,5.255,0,0,0,7,10.5ZM7,1.75a3.5,3.5,0,1,1-3.5,3.5A3.5,3.5,0,0,1,7,1.75Zm7,17.5v.875a.875.875,0,1,1-1.75,0V19.25a5.25,5.25,0,0,0-10.5,0v.875a.875.875,0,1,1-1.75,0V19.25a7,7,0,0,1,14,0ZM20.735,8.94l-3.493,3.391a2.742,2.742,0,0,1-3.868-.009L11.65,10.7a.875.875,0,0,1,1.2-1.274l1.743,1.641a1,1,0,0,0,1.42.018l3.5-3.4A.875.875,0,1,1,20.734,8.94Z",
    fill: "#ff6036"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAssi);
export default __webpack_public_path__ + "static/media/userAssi.157f8dd6929d27b660bcc747f7fb619d.svg";
export { ForwardRef as ReactComponent };